import { Switch } from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { defaultTooltipRender, EmptyPagination } from './TableBox';

const TableNoPageBox = ({ defaultWide = true }) => {
    const {
        control: { columns, onRowDoubleClick, onRowClick, params },
        gridData: { rows, totalCount, page, pageSize },
    } = useSelector((state) => state.tableNoPageBoxState);

    const [wideChecked, setWideChecked] = useState(defaultWide);

    const onClickWide = (e) => {
        setWideChecked(e.target.checked);
    };

    return (
        <>
            <div className={'result-table-box ' + (wideChecked ? 'wide' : '')}>
                <div className='grid-table'>
                    <div className='grid-table-head right'>
                        <div className='head-select'>
                            <div>와이드모드</div>
                            <Switch
                                checked={wideChecked}
                                onChange={(e) => onClickWide(e)}
                                name='확대/보통'
                                color='primary'
                            />
                        </div>
                    </div>
                    <div className='grid-table-body'>
                        {columns.length > 0 ? (
                            <DataGrid
                                autoHeight
                                hideFooterSelectedRowCount
                                pagination
                                page={page}
                                pageSize={pageSize}
                                paginationMode='server'
                                columns={
                                    columns &&
                                    columns.map((column) =>
                                        column.tooltip
                                            ? {
                                                  ...column,
                                                  renderCell: (params) => defaultTooltipRender(params, column),
                                              }
                                            : column,
                                    )
                                }
                                rows={rows}
                                rowCount={totalCount}
                                onRowDoubleClick={(item) => onRowDoubleClick(item.row, params)}
                                onRowClick={onRowClick && onRowClick}
                                components={{
                                    Pagination: EmptyPagination,
                                }}
                                sx={{
                                    '.MuiDataGrid-columnSeparator': {
                                        display: 'none',
                                    },
                                    '&.MuiDataGrid-root': {
                                        borderLeft: 'none',
                                        borderRight: 'none',
                                        borderBottom: 'none',
                                        fontFamily: 'inherit',
                                    },
                                }}
                            />
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default TableNoPageBox;
